/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbContactSummary } from './HchbContactSummary';
import {
    HchbContactSummaryFromJSON,
    HchbContactSummaryFromJSONTyped,
    HchbContactSummaryToJSON,
} from './HchbContactSummary';

/**
 * 
 * @export
 * @interface HchbFacilitySummary
 */
export interface HchbFacilitySummary {
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    telephone?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    facility_type?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    county?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    npi?: string;
    /**
     * 
     * @type {Array<HchbContactSummary>}
     * @memberof HchbFacilitySummary
     */
    contacts?: Array<HchbContactSummary>;
}

/**
 * Check if a given object implements the HchbFacilitySummary interface.
 */
export function instanceOfHchbFacilitySummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function HchbFacilitySummaryFromJSON(json: any): HchbFacilitySummary {
    return HchbFacilitySummaryFromJSONTyped(json, false);
}

export function HchbFacilitySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbFacilitySummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'telephone': !exists(json, 'telephone') ? undefined : json['telephone'],
        'facility_type': !exists(json, 'facility_type') ? undefined : json['facility_type'],
        'street': !exists(json, 'street') ? undefined : json['street'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
        'county': !exists(json, 'county') ? undefined : json['county'],
        'npi': !exists(json, 'npi') ? undefined : json['npi'],
        'contacts': !exists(json, 'contacts') ? undefined : ((json['contacts'] as Array<any>).map(HchbContactSummaryFromJSON)),
    };
}

export function HchbFacilitySummaryToJSON(value?: HchbFacilitySummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'city': value.city,
        'state': value.state,
        'telephone': value.telephone,
        'facility_type': value.facility_type,
        'street': value.street,
        'zip': value.zip,
        'county': value.county,
        'npi': value.npi,
        'contacts': value.contacts === undefined ? undefined : ((value.contacts as Array<any>).map(HchbContactSummaryToJSON)),
    };
}

